export default __webpack_public_path__ + "static/media/Front-Apartment-Mr-El-Sayid-8.0bb872ec.jpg";